module.exports = __webpack_public_path__ + "static/media/3 04 Tulleord Modil er feil.c4e3d040.mp3";